import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { Store } from '@ngxs/store';

import { environment } from '../../environments/environment';
import { PermissionGuard } from '../shared/guards/permission.guard';
import { SharedModule } from '../shared/shared.module';
import { GetPerPages, GetRules, ValidateUser } from '../store/app.actions';

import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { LoginComponent } from './login/login.component';
import { LoginByMicrosoftRedirectUrlComponent } from './login-by-microsoft-redirect-url/login-by-microsoft-redirect-url.component';
import { NoopSessionChecker, SessionCheckerService } from './session-checker.service';


export function initApp(store: Store) {
  return (): Promise<unknown> => store.dispatch([new ValidateUser(), new GetPerPages(), new GetRules()]).toPromise();
}

@NgModule({
  declarations: [LoginComponent, LoginByMicrosoftRedirectUrlComponent],
  imports: [CommonModule, SharedModule],
  exports: [LoginComponent, LoginByMicrosoftRedirectUrlComponent],
  providers: [
    AuthService,
    AuthGuard,
    PermissionGuard,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [Store],
      multi: true,
    },
    { provide: SessionCheckerService, useClass: environment.sessionChecker?.enabled ? SessionCheckerService : NoopSessionChecker },
  ],
})
export class AuthModule {}
